var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "concierce_info" }, [
      _c("div", { staticClass: "inner" }, [
        _c("div", { staticClass: "info_box_white" }, [
          _c("h2", { staticClass: "title" }, [
            _vm._v("건강한 웰니스 에너지 충전,"),
            _c("br"),
            _vm._v("파이토 카페 음료 바우처 이용안내")
          ]),
          _vm._v(" "),
          _c("dl", { staticClass: "info_detail" }, [
            _c("dt", [_vm._v("장소")]),
            _vm._v(" "),
            _c("dd", [
              _c("h2", { staticClass: "info_place" }, [
                _vm._v("파이토 카페가 있는 전국 ABC/A STATION")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "info_place_area" }, [
                _vm._v(
                  "(분당/강서/인천/대전/울산/부산/창원/전주 ABC 및 A STATION)"
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("p", { staticClass: "info_place_area" }, [
                _vm._v(
                  "※ 파이토 카페가 없는 ABC의 경우, XS 에너지 음료로 대체 사용 가능"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "info_place_area" }, [
                _vm._v("    (대구, 광주, 청주, 강릉, 제주 ABC)")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dl", { staticClass: "info_detail" }, [
            _c("dt", [_vm._v("이용안내")]),
            _vm._v(" "),
            _c("dd", [
              _c("ul", { staticClass: "info_list info_list-gray" }, [
                _c("li", [
                  _vm._v(
                    "바우처 1장당 음료 한잔 (3,500원 가격) 선택이 가능합니다. (베이커리, 스낵 제외)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "파이토 카페가 없는 ABC의 경우, 바우처 1장당 XS 에너지 음료 한 개로 교환 가능합니다."
                  ),
                  _c("br"),
                  _vm._v(
                    "(XS 그레이프 후르츠, XS 니온, XS 크랜베리, XS ELITE 피치, XS 아쿠아블라스트, XS 푸로틴워터 20)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3,500원 이상 음료 선택 시, 추가 금액은 별도 결제 가능합니다. (3,500원 미만 음료는 차액 지불 미적용)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("바우처는 현금으로 교환 및 잔액 환불이 불가합니다.")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "음료 선택 후, 파이토 카페 직원에게 바우처를 제시해 주시기 바랍니다.\n                          "
                  ),
                  _vm._v(
                    "\n                          (파이토 카페가 없는 경우, 인포메이션에서 확인 가능합니다.)\n                          "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dl", { staticClass: "info_detail" }, [
            _c("dt", [_vm._v("유의사항")]),
            _vm._v(" "),
            _c("dd", [
              _c("ul", { staticClass: "info_list info_list-gray" }, [
                _c("li", [_vm._v("이용기한은 바우처 표기기한까지 입니다.")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "이용기한 내 바우처 미사용 시, 분실 시 재발급 불가합니다."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("바우처가 포함된 메시지 삭제 시, 재발송 불가합니다.")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "바우처 선물 받으실 분의 휴대폰 번호를 정확히 입력해 주시기 바랍니다. 바우처 발송 후 회수 및 취소 불가합니다."
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("양도/양수 가능합니다.")])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info_box_gray" }, [
          _c("h2", [_vm._v("후원수당 및 소득과세 관련 유의사항")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "다이아몬드 컨시어지 마이랩 마이크로바이옴 솔루션 서비스는 법률상 후원수당 및 사업소득에 해당됩니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "info_list info_list-white" }, [
            _c("li", [
              _vm._v(
                "방판법과 소득세법에 따라, 마이랩 마이크로바이옴 테스트 키트 "
              ),
              _c("span", [
                _vm._v(
                  "판매가에 기준하여 소득에 포함되며 종합소득세 신고됩니다."
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", [
                _vm._v(
                  "바우처 사용 유무에 관계없이, 지급 시점에 원수령자인 다이아몬드 이상 리더님께 과세됩니다. 이용기한내에 사용하시길 권장드립니다."
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", [
                _vm._v(
                  "바우처 수령 후, 분실, 미사용, 유효기간 만료된 바우처에 대해서도 소득 취소 불가하며, 과세됨을 알려드립니다."
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "유자격 시 지급받은 혜택은 기한 내에 사용 가능하며, 자격상실 이후에는 혜택이 제공되지 않습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "월별 윤리 강령 이슈자는 다이아몬드 컨시어지 서비스 대상자에서 제외됩니다."
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42671694", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42671694","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/concierge/component/infotag.vue
// module id = null
// module chunks = 